export class Project {
    project_id: number;
    nom: string;
    date: Date = null;
    project_img: string;
    lien: string;
    admin_id: string;
    category_id: string;
}